export const MENU_ICON = {
    // webmap_json
    '特報與即時訊息': 'icon-real-time-info',
    '客製化警示': 'icon-customized-warning',
    '雷達觀測': 'icon-radar-observation',
    'Radar': 'icon-radar-observation',
    '地面觀測': 'icon-ground-observation',
    'Observations': 'icon-ground-observation',
    '衛星雲圖': 'icon-invalid-name',
    '衛星產品': 'icon-invalid-name',
    'Satellite': 'icon-invalid-name',
    '閃電觀測': 'icon-thunder-observation',
    'Lightning': 'icon-thunder-observation',
    '颱風資訊': 'icon-typhoon-info',
    'Typhoon': 'icon-typhoon-info',
    '集水區雨量預報': 'icon-watershed-rainfall-forecast',
    '水庫集水區雨量產品': 'icon-watershed-rainfall-forecast',
    '雷達定量降雨預報': 'icon-radar-rainfall-forecast',
    'Radar-based Nowcast': 'icon-radar-rainfall-forecast',
    '定量降雨預報': 'icon-pattern-rainfall-forecast',
    '累積雨量計算': 'icon-accumulated-rainfall',
    '投落送': 'icon-airplane',
    '模式定量降水預報': 'icon-rain-nowcast',
    '海象預報': 'icon-sea-forecast',
    '雷達基本產品': 'icon-radar-observation',
    '雷達定量降水估計': 'icon-radar-rainfall-forecast',
    '降水預報產品': 'icon-rain-nowcast',
    '劇烈天氣分析': 'icon-weather-analysis',
    '風場分析產品': 'icon-wind-analysis',
    '兩分鐘雷達產品': 'icon-radar-2mins',

    // atlas
    '短期定量降水預報': 'icon-cwa-gfs-daily-rainfall',
    '日雨量': 'icon-daily-rainfall',
    '週雨量': 'icon-weekly-rainfall',
    '月雨量': 'icon-monthly-rainfall',
    '日雨量趨勢': 'icon-daily-rainfall-trend',
    '未來兩周降雨分析': 'icon-next-2-week-rainfall-analysis',
    '短期預報雨量圖(0~24HR)': 'icon-short-term-rainfall-forecast',
    '24小時與72小時累積雨量圖': 'icon-24-72-hour-rainfall',
    '24小時鐵路沿線累積雨量圖': 'icon-24-hour-tra-rainfall',
    '工務段雨量': 'icon-construction-rainfall',
    '一週地面天氣圖': 'icon-weekly-surface-weather',
    '一週風力報表': 'icon-weekly-wind-report',
    '一週波浪預報': 'icon-weekly-wave-forecast',
    '南沙一週預報': 'icon-nansha-weekly-forecast',
    '颱風1-4週侵襲潛勢預報': 'icon-typhoon-forecast',
    '乾旱指標': 'icon-drought-indicators',
    '台灣海域警戒': 'icon-mpb-120hrs',

    // monitor
    '氣象觀測': 'icon-weather-observation',
    '海象觀測': 'icon-sea-forecast',
    '警示': 'icon-warning',
    '路線雨量': 'icon-road-rainfall',
    '集水區與流域雨量': 'icon-watershed-rainfall-forecast',

    // geomap_json
    '港口資訊': 'icon-pier',
    '水文資訊': 'icon-hydrology',
    'Local Hydrology': 'icon-hydrology',
    '鐵道資訊': 'icon-railway-new',
    '即時路況圖資': 'icon-timely-road',
    '即時路況高公局圖資': 'icon-timely-road',
    '即時路況': 'icon-timely-road',
    '公路資訊': 'icon-road',
    '車站資訊': 'icon-station',
    '機場資訊': 'icon-airplane',
    '航空資訊-機場': 'icon-airplane',
    '航空資訊-航路': 'icon-airplane-road',
    '航空資訊-飛航待命區': 'icon-airplane-standby-block',
    '警示地圖': 'icon-warning-map',
    '桃園機場': 'icon-taoyuan-ainplane',
    '高鐵圖資': 'icon-taiwan-high-speed-rail',
    '日月潭纜車': 'icon-sunmoonlake-gondola',
    '沿海資訊': 'icon-coastal-information',
    '客製化預警區': 'icon-custom-warning-block',
    '地理資訊': 'icon-geographic-information',
    '臺北市政府': 'icon-taipei-government'
}

export const EXISTING_MENU_SLIDER_GROUP_LIST = [  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_650": "1",      
            "id_651": "3",      
            "id_652": "6",      
            "id_653": "12",      
            "id_654": "24"    
        }  
    },  
    {    
        "hint": "小時閃電頻率",    
        "hint_en": "frequency per hour",    
        "dict": {      
            "id_57": "1",      
            "id_58": "3",      
            "id_59": "6",      
            "id_60": "12",      
            "id_61": "24"    
        }  
    },  
    {    
        "hint": "小時累積雨量",
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_660": "1",      
            "id_661": "3",      
            "id_662": "6",      
            "id_663": "12",      
            "id_664": "24"   
        }  
    },  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_10": "1",      
            "id_11": "3",      
            "id_12": "6",      
            "id_24": "24",      
            "id_32": "12"    
        }  
    },  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_670": "1",      
            "id_671": "3",      
            "id_672": "6",      
            "id_673": "12",      
            "id_674": "24"    
        }  
    },  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_26": "1",      
            "id_27": "3",      
            "id_28": "6",      
            "id_29": "12",      
            "id_30": "24",      
            "id_31": "72"    
        }  
    },  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_47": "1",      
            "id_48": "3",      
            "id_49": "6",      
            "id_50": "12",      
            "id_51": "24"   
        }  
    },  
    {    
        "hint": "高度層(公里)",    
        "hint_en": "hight(km)",   
        "dict": {      
            "id_200": "2",      
            "id_201": "4",      
            "id_202": "6",      
            "id_203": "8",      
            "id_204": "15"    
        }  
    },  
    {    
        "hint": "小時閃電頻率",    
        "hint_en": "frequency per hour",    
        "dict": {      
            "id_831": "1",      
            "id_832": "3",      
            "id_833": "6",      
            "id_834": "12",      
            "id_835": "24",      
            "id_836": "72"   
        }  
    },  
    {    
        "hint": "小時累積雨量",    
        "hint_en": "rainfall per hour",    
        "dict": {      
            "id_52": "1",      
            "id_53": "3",      
            "id_54": "6",      
            "id_55": "12",      
            "id_56": "24"    
        }  
    }
]